import React from 'react';
import { getPwaWorkspaceConfig } from '../config/workspace-config';

export const SplashScreen: React.FC = () => {
  const wsConfig = getPwaWorkspaceConfig();
  const appName = wsConfig.appName || 'Console';
  const primaryColor = wsConfig.branding?.primaryColor || '#8B5CF6';

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0B0F19',
        padding: '24px',
        height: '100%',
      }}
    >
      <div
        style={{
          fontSize: '32px',
          fontWeight: '900',
          letterSpacing: '4px',
          color: '#fff',
          textAlign: 'center',
          textTransform: 'uppercase',
        }}
      >
        {appName}
      </div>
      <div
        style={{
          fontSize: '12px',
          letterSpacing: '2px',
          color: primaryColor,
          marginTop: '8px',
          fontWeight: '700',
          textTransform: 'uppercase',
        }}
      >
        GAMES PLATFORM
      </div>
      <div style={{ marginTop: '24px' }}>
        <div
          style={{
            width: '32px',
            height: '32px',
            border: `3px solid ${primaryColor}33`,
            borderTop: `3px solid ${primaryColor}`,
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
};
